import { render, staticRenderFns } from "./BaseBrainTree.vue?vue&type=template&id=1a03e8ec&"
import script from "./BaseBrainTree.vue?vue&type=script&lang=js&"
export * from "./BaseBrainTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports